import { defineMessage } from 'services/localization';

export const messages = {
    markAsCloseButton: defineMessage('close_po'),
    closedStatus: defineMessage('closed'),
    markAsOpenButton: defineMessage('switch_to_open'),
};
